var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailAlertM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.249 2.50098C6.20817 2.50645 4.61582 2.58112 3.59819 3.59891C2.5 4.69727 2.5 6.46507 2.5 10.0006C2.5 13.5362 2.5 15.3041 3.59819 16.4024C4.69638 17.5008 6.4639 17.5008 9.99895 17.5008C13.5339 17.5008 15.3014 17.5008 16.3997 16.4024C17.4172 15.3846 17.4919 13.792 17.4974 10.7507",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1298 2.91415L9.20703 10.8829M17.1298 2.91415C16.7182 2.50197 13.9451 2.54039 13.3588 2.54873M17.1298 2.91415C17.5414 3.32633 17.5031 6.10299 17.4948 6.68999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailAlertM);
export default __webpack_public_path__ + "static/media/detail-alert-m.e8a0e7fdf0f563f47c065d78872124a0.svg";
export { ForwardRef as ReactComponent };